import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Navigate } from 'react-router';

import api from '../actions/EndPoints';
import axiosInstance from '../actions/AxiosInstance';
import { dispatchOverlayLoad } from '../components/shared/Analytics';
import connectWithUserStore from '../reducers/connectWithUserStore';
import {
    encodedUrlTextNew,
    engagementType,
    getIsRasHH,
    isConsentUrl,
    log,
    matchPathname,
    setLastRequestTime,
    showModal,
    scrollTo,
} from '../Utils';
import ConsentViewContainer from './ConsentViewContainer';
import { EDeliveryConsentContent, InvestmentInfoContent, KeypointsContent, ProspectusesContent } from '../components/ConsentComponents/ConsentContent';
import { GENERAL_HUB_ERROR_MODAL, HUB_GENERAL_ERROR_OVERLAY } from '../Constants';

const checkIfCoClient = () => {
    const isOnCoClientConsentRoute = window.location.pathname.indexOf('co-client-consent') !== -1 &&
        window.location.pathname.indexOf('reenroll') === -1;

    log(console.log('is On CoClient Consent Route: ', isOnCoClientConsentRoute));
    return isOnCoClientConsentRoute;
}


const ConsentViewComponent = connectWithUserStore(({ state, dispatch, profiler }) => {
    const {
        apiKey,
        engagementStatus,
        currentClientData,
        isPrimary,
        isRegisteredUser,
        numberOfClients,
        isCustomerWebView,
    } = state;
    const keyPointsControl = document.querySelectorAll(`[id="checkedKeyPoints-control"]`)[0];
    const keyPointsCheckbox = document.querySelectorAll(`[id="checkedKeyPoints"]`)[0];
    const eDeliveryControl = document.querySelectorAll(`[id="checkedEdelivery-control"]`)[0];
    const eDeliveryCheckbox = document.querySelectorAll(`[id="checkedEdelivery"]`)[0];
    const prospectusesControl = document.querySelectorAll(`[id="checkedProspectuses-control"]`)[0];
    const prospectusesCheckbox = document.querySelectorAll(`[id="checkedProspectuses"]`)[0];
    const advControl = document.querySelectorAll(`[id="client-agreement-control"]`)[0];
    const advCheckbox = document.querySelectorAll(`[id="agreementAdv"]`)[0];
    const invInfoControl = document.querySelectorAll(`[id="checked-confirmation-control"]`)[0];
    const invInfoCheckbox = document.querySelectorAll(`[id="checkedConfirmation"]`)[0];
    const [notificationContent, setNotificationContent] = React.useState([]);
    const isProspCompleted =
        state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
            (x) => x.status === 'FPAC'
        ) &&
        state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
            (x) => x.status === 'APND'
        );
    const isProspClient = state?.planningGroup?.activeEngagement?.engagementStatuses?.some(
        (x) => x.status === 'NEWP'
    );

    const [checkError, setCheckError] = React.useState({
        checkedKeyPoints: false,
        checkedEdelivery: false,
        checkedProspectuses: false,
        checkedAdv: false,
        checkedConfirmation: false,
    });
    const [checkState, setCheckState] = React.useState({
        checked401k: false,
        checkedYodlee: false,
        checkedTrust: false,
        checkedKeyPoints: false,
        checkedEdelivery: false,
        checkedProspectuses: false,
        checkedAdv: false,
        checkedConfirmation: false,
    });
    const [openModalState, setOpenModalState] = React.useState(false);
    const [inProgress, setConsentInProgress] = React.useState(false);
    const [success, setSuccess] = React.useState(false);

    const handleCheckboxErrors = () => {
        setConsentInProgress(false);
        const getScrollId = () => {
            if (!checkState.checkedKeyPoints) {
                return 'key-points-container-header';
            }
            if (!checkState.checkedEdelivery) {
                return 'edelivery-container-header';
            }
            if (!checkState.checkedProspectuses) {
                return 'prospectuses-container-header';
            }
            if (!checkState.checkedAdv) {
                return 'client-agreement-container-header';
            }
            if (!checkState.checkedConfirmation) {
                return 'inv-info-container-header';
            }
            return '';
        };

        setCheckError({
            ...checkError,
            checkedProspectuses: !checkState.checkedProspectuses,
            checkedAdv: !checkState.checkedAdv,
            checkedEdelivery: !checkState.checkedEdelivery,
            checkedKeyPoints: !checkState.checkedKeyPoints,
            checkedConfirmation: !checkState.checkedConfirmation,
        });
        if (!checkState.checkedConfirmation) {
            invInfoCheckbox.checkValidity();
        }
        if (!checkState.checkedAdv) {
            advCheckbox.checkValidity();
        }
        if (!checkState.checkedProspectuses) {
            prospectusesCheckbox.checkValidity();
        }
        if (!checkState.checkedEdelivery) {
            eDeliveryCheckbox.checkValidity();
        }
        if (!checkState.checkedKeyPoints) {
            keyPointsCheckbox.checkValidity();
        }

        scrollTo(getScrollId());
    };

    const profileRouteCheck =
        profiler &&
        matchPathname([`/usis/advice/fps${profiler.route}`, `/usis/advice/fps${profiler.route}/`])
            .length !== 0;
    const isRasHH = getIsRasHH(state.planningGroup, engagementStatus);
    const getEngagementType = engagementType(isRasHH, isPrimary);
    log(console.log('User Profile: ', profiler));

    const isCoClientJoin =
        profiler &&
        (profiler.type === 'ONBOARDING_CO_CLIENT' || profiler.type === 'BTR_CO_CLIENT_CONSENT');

    const handleChange = (name) => (event) => {
        setCheckState({ ...checkState, [name]: event.target.checked });
    };

    React.useEffect(() => {
        if (checkState?.checkedKeyPoints) {
            Promise.resolve(keyPointsControl.removeAttribute('invalid'))
                .then(() => keyPointsCheckbox.removeAttribute('aria-invalid'))
                .then(() =>
                    setCheckError((prevState) => ({ ...prevState, checkedKeyPoints: false }))
                );
        }
        if (checkState?.checkedEdelivery) {
            Promise.resolve(eDeliveryControl.removeAttribute('invalid'))
                .then(() => eDeliveryCheckbox.removeAttribute('aria-invalid'))
                .then(() =>
                    setCheckError((prevState) => ({ ...prevState, checkedEdelivery: false }))
                );
        }
        if (checkState?.checkedProspectuses) {
            Promise.resolve(prospectusesControl.removeAttribute('invalid'))
                .then(() => prospectusesCheckbox.removeAttribute('aria-invalid'))
                .then(() =>
                    setCheckError((prevState) => ({ ...prevState, checkedProspectuses: false }))
                );
        }
        if (checkState?.checkedAdv) {
            Promise.resolve(advControl.removeAttribute('invalid'))
                .then(() => advCheckbox.removeAttribute('aria-invalid'))
                .then(() => setCheckError((prevState) => ({ ...prevState, checkedAdv: false })));
        }
        if (checkState?.checkedConfirmation) {
            Promise.resolve(invInfoControl.removeAttribute('invalid'))
                .then(() => invInfoCheckbox.removeAttribute('aria-invalid'))
                .then(() =>
                    setCheckError((prevState) => ({ ...prevState, checkedConfirmation: false }))
                );
        }
    }, [checkState]);


    React.useEffect(() => {
        const keyPointsErr = { section: 'I', content: KeypointsContent.checbkoxLabel, error: checkError.checkedKeyPoints }
        const eDelError = { section: 'II', content: EDeliveryConsentContent.checkboxLabel, error: checkError.checkedEdelivery }
        const prospectusesErr = { section: 'III', content: ProspectusesContent.checkboxLabel, error: checkError.checkedProspectuses }
        const advInfoErr = { section: 'IV', content: 'I agree', error: checkError.checkedAdv }
        const confErr = {
            section: 'V',
            content: InvestmentInfoContent.checkboxLabel,
            error: checkError.checkedConfirmation,
        };

        setNotificationContent([keyPointsErr, eDelError, prospectusesErr, advInfoErr, confErr])
    }, [checkError])


    const clearStorageKeys = (keys) => {
        keys.forEach((k) => localStorage.removeItem(k));
        keys.forEach((k) => sessionStorage.removeItem(k));
    };

    const getRedirectUrl = () => {
        return !isProspCompleted && isProspClient
            ? '/usis/advice/fps/appointment-info'
            : '/usis/advice/fps/profile';
    };

    const handleCoClientSuccess = (keysToRemove) => {
        clearStorageKeys(keysToRemove);
        dispatch({ type: 'CONSENT_UPDATED', isConsented: true });
        window.location.replace(getRedirectUrl());
        setConsentInProgress(false);
        setSuccess(true);
    };

    const isMultiClientScenario = () => {
        return numberOfClients > 1 || currentClientData?.clientType === 'COCLIENT' || isCoClientJoin;
    };

    const handleMultiClientSuccess = () => {
        window.location.replace(getRedirectUrl());
        setOpenModalState(true);
        setConsentInProgress(false);
        setSuccess(true);
    };

    const handleSingleClientSuccess = () => {
        showModal('post-consent-invite-partner-modal');
        dispatchOverlayLoad('Add Co-Client');
        setOpenModalState(true);
        setSuccess(true);
        setConsentInProgress(false);
    };

    const handlePrimaryClientSuccess = (keysToRemove) => {
        clearStorageKeys(keysToRemove);
        dispatch({ type: 'CONSENT_UPDATED', isConsented: true });

        if (isMultiClientScenario()) {
            handleMultiClientSuccess();
        } else {
            handleSingleClientSuccess();
        }
    };

    const handleConsentSuccess = (keysToRemove) => {
        setLastRequestTime();

        if (checkIfCoClient()) {
            handleCoClientSuccess(keysToRemove);
        } else {
            handlePrimaryClientSuccess(keysToRemove);
        }
    };

    const isExpiredCoClientUrl = (error) => {
        return (
            checkIfCoClient() &&
            error.response?.data?.httpStatusCode === 401 &&
            error.response?.data?.message === 'Co-Client Url is not valid'
        );
    };

    const handleConsentError = (error, keysToRemove) => {
        setConsentInProgress(false);
        setLastRequestTime();
        clearStorageKeys(keysToRemove);

        if (isExpiredCoClientUrl(error)) {
            window.location.replace('/usis/advice/fps/invitation-expired');
        } else {
            showModal(GENERAL_HUB_ERROR_MODAL);
            console.log(error);
            dispatchOverlayLoad(HUB_GENERAL_ERROR_OVERLAY);
            setOpenModalState(true);
        }
    };

    const buildConsentPayload = () => {
        const basePayload = {
            consent401k: checkState.checked401k,
            consentYodleeIndicator: checkState.checkedYodlee,
            consentTrust: checkState.checkedTrust,
            consentEDelivery: true,
            engagementType: getEngagementType,
        };

        if (isCoClientJoin) {
            return {
                coClientVerificationRequest: {
                    encodedUrlText: encodedUrlTextNew(),
                    invitePinNumber: sessionStorage.getItem('invitePinNumber'),
                },
                clientConsentRequest: basePayload,
            };
        }

        return basePayload;
    };

    const areAllCheckboxesValid = () => {
        return (
            checkState.checkedAdv &&
            checkState.checkedKeyPoints &&
            checkState.checkedEdelivery &&
            checkState.checkedProspectuses &&
            checkState.checkedConfirmation
        );
    };

    const handleDispatch = () => {
        if (!areAllCheckboxesValid()) {
            handleCheckboxErrors();
            return;
        }

        setConsentInProgress(true);
        const keysToRemove = ['emailInv', 'invitePinNumber', 'joiningRasHH'];
        const apiEndpoint = isCoClientJoin ? api.coClientConsentAPI : api.consentAPI;
        const payload = buildConsentPayload();

        axiosInstance
            .post(apiEndpoint, payload, {
                headers: { apikey: apiKey },
            })
            .then((res) => {
                if (res) {
                    handleConsentSuccess(keysToRemove);
                }
            })
            .catch((error) => {
                handleConsentError(error, keysToRemove);
            });
    };

    if ((profileRouteCheck && isConsentUrl(profiler.route)) || openModalState) {
        return (
            <ConsentViewContainer
                handleChange={handleChange}
                checkError={checkError}
                checkState={checkState}
                notificationContent={notificationContent}
                setCheckState={setCheckState}
                handleDispatch={handleDispatch}
                inProgress={inProgress}
                isPrimary={isPrimary}
                isRegisteredUser={isRegisteredUser}
                numberOfClients={numberOfClients}
                success={success}
                isCustomerWebView={isCustomerWebView}
            />
        );
    }

    log(console.log('show default - go to correct route'));
    return <Navigate push to={profiler?.route} />;
});

export default function ConsentView() {
    return <ConsentViewComponent />;
}
